import { render, staticRenderFns } from "./FishingRules.vue?vue&type=template&id=00d92a46&scoped=true&"
import script from "./FishingRules.vue?vue&type=script&lang=js&"
export * from "./FishingRules.vue?vue&type=script&lang=js&"
import style0 from "./FishingRules.vue?vue&type=style&index=0&id=00d92a46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d92a46",
  null
  
)

export default component.exports